import axios, { AxiosError } from 'axios'
import Cookies from 'js-cookie'
import { Fragment, useState } from 'react'
import { string } from 'yup'
import stringEntropy from 'fast-password-entropy'
import { InputOnly, InputWithButton } from '@proj-client/components/generic/inputElements'
import { MIN_PASSWORD_STRENGTH } from '@proj-common/const'
import { useEventStore } from '@proj-client/stores/eventStore'
import { useUserDataStore } from '@proj-client/stores/userDataStore'

const NameComponent = (props) => {
    const userData = useUserDataStore()
    const event = useEventStore(store => store.event)

    const [userName, setUserName] = useState(userData.user_name)
    const [validationErrors, setValidationErrors] = useState([])

    const [buttonIcon, setButtonIcon] = useState(<i className="fa-solid fa-floppy-disk"></i>)
    const [buttonExtraClassNames, setButtonExtraClassNames] = useState('bg-indigo-500 hover:bg-indigo-700 text-white')
    const [buttonDisabled, setButtonDisabled] = useState(userData.email == "demo@ideate.live" ? true : false)

    const revertButtonStyle = () => {
        setButtonIcon(<i className="fa-solid fa-floppy-disk"></i>)
        setButtonExtraClassNames('bg-indigo-500 hover:bg-indigo-700 text-white')
        setButtonDisabled(false)
    }

    const nameValidator = string().trim().min(1)

    const handleNameChange = async () => {
        if (await nameValidator.validate(userName)) {
            setButtonIcon(<i className="fa-solid fa-circle-notch fa-spin"></i>)
            setButtonExtraClassNames('bg-indigo-500 hover:bg-indigo-700 text-white')
            setButtonDisabled(true)

            axios.post(userData.user_type == 'registered' ? `/api/users/${userData.user_id}/modify/name` : `/api/events/${event?.id}/participants/${event?.participant.id}/modify/name`, {
                name: userName.trim(),
                event_id: event?.id,
            }).then(() => {
                setButtonIcon(<i className="fa-solid fa-circle-check"></i>)
                setButtonExtraClassNames('bg-green-500 hover:bg-green-700 text-white')
                setButtonDisabled(false)
                userData.setUserName(userName.trim())
                userData.setSessionName(userName.trim())
                setUserName(userName.trim())
            }).catch((e: AxiosError<{ error: string }>) => {
                if (e.response?.data?.error) {
                    // TODO
                }
            })
        }
    }

    return (
        <Fragment>
            <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:grid-cols-3 '>
                <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">Name</label>
                <InputWithButton
                    extraClassNames='sm:col-span-2'
                    buttonExtraClassNames={buttonExtraClassNames}
                    value={userName}
                    autocomplete={false}
                    buttonLabel={buttonIcon}
                    buttonAction={handleNameChange}
                    disabled={buttonDisabled}
                    onEnterKeyPressed={handleNameChange}
                    onInputChanged={(new_value) => {
                        setUserName(new_value)
                        revertButtonStyle()
                        setValidationErrors([])
                    }}
                    validationErrors={validationErrors} />
                <div className="mt-1 sm:col-span-3">You will be visible as such in any new ideate.live event you may join in the future.</div>
            </div>
        </Fragment>
    )
}




const MetadataComponent = (props) => {
    const userData = useUserDataStore()
    const event = useEventStore(store => store.event)

    const [company, setCompany] = useState(userData.metadata.company)
    const [role, setRole] = useState(userData.metadata.role)

    const [companyButtonIcon, setCompanyButtonIcon] = useState(<i className="fa-solid fa-floppy-disk"></i>)
    const [roleButtonIcon, setRoleButtonIcon] = useState(<i className="fa-solid fa-floppy-disk"></i>)
    const [companyButtonExtraClassNames, setCompanyButtonExtraClassNames] = useState('bg-indigo-500 hover:bg-indigo-700 text-white')
    const [roleButtonExtraClassNames, setRoleButtonExtraClassNames] = useState('bg-indigo-500 hover:bg-indigo-700 text-white')
    const [companyButtonDisabled, setCompanyButtonDisabled] = useState(userData.email == "demo@ideate.live" ? true : false)
    const [roleButtonDisabled, setRoleButtonDisabled] = useState(userData.email == "demo@ideate.live" ? true : false)


    const handleCompanyChange = async () => {
        setCompanyButtonIcon(<i className="fa-solid fa-circle-notch fa-spin"></i>)
        setCompanyButtonExtraClassNames('bg-indigo-500 hover:bg-indigo-700 text-white')
        setCompanyButtonDisabled(true)

        axios.post(userData.user_type == 'registered' ? `/api/users/${userData.user_id}/modify/metadata` : `/api/events/${event.id}/participants/${event.participant.id}/modify/metadata`, {
            company: company,
            event_id: event?.id
        }).then(() => {
            setCompanyButtonIcon(<i className="fa-solid fa-circle-check"></i>)
            setCompanyButtonExtraClassNames('bg-green-500 hover:bg-green-700 text-white')
            setCompanyButtonDisabled(false)
            userData.setMetadata({
                ...userData.metadata,
                company: company
            })
        }).catch((e: AxiosError<{ error: string }>) => {
            if (e.response?.data?.error) {
                // TODO
            }
        })
    }
    const handleRoleChange = async () => {
        setRoleButtonIcon(<i className="fa-solid fa-circle-notch fa-spin"></i>)
        setRoleButtonExtraClassNames('bg-indigo-500 hover:bg-indigo-700 text-white')
        setRoleButtonDisabled(true)

        axios.post(userData.user_type == 'registered' ? `/api/users/${userData.user_id}/modify/metadata` : `/api/events/${event.id}/participants/${event.participant.id}/modify/metadata`, {
            role: role,
            event_id: event?.id
        }).then(() => {
            setRoleButtonIcon(<i className="fa-solid fa-circle-check"></i>)
            setRoleButtonExtraClassNames('bg-green-500 hover:bg-green-700 text-white')
            setRoleButtonDisabled(false)
            userData.setMetadata({
                ...userData.metadata,
                role: role
            })
        }).catch((e: AxiosError<{ error: string }>) => {
            if (e.response?.data?.error) {
                // TODO
            }
        })
    }

    const revertRoleButtonStyle = () => {
        setRoleButtonIcon(<i className="fa-solid fa-floppy-disk"></i>)
        setRoleButtonExtraClassNames('bg-indigo-500 hover:bg-indigo-700 text-white')
        setRoleButtonDisabled(false)
    }
    const revertCompanyButtonStyle = () => {
        setCompanyButtonIcon(<i className="fa-solid fa-floppy-disk"></i>)
        setCompanyButtonExtraClassNames('bg-indigo-500 hover:bg-indigo-700 text-white')
        setCompanyButtonDisabled(false)
    }

    return (
        <Fragment>
            <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:grid-cols-3 '>
                <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">Company</label>
                <InputWithButton
                    extraClassNames='sm:col-span-2'
                    value={company}
                    autocomplete={false}
                    buttonLabel={companyButtonIcon}
                    buttonAction={handleCompanyChange}
                    disabled={companyButtonDisabled}
                    onEnterKeyPressed={handleCompanyChange}
                    onInputChanged={(new_value) => {
                        revertCompanyButtonStyle()
                        setCompany(new_value)
                    }}
                    buttonExtraClassNames={companyButtonExtraClassNames} />
            </div>
            <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:grid-cols-3 '>
                <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">Role</label>
                <InputWithButton
                    extraClassNames='sm:col-span-2'
                    value={role}
                    autocomplete={false}
                    buttonLabel={roleButtonIcon}
                    buttonAction={handleRoleChange}
                    disabled={roleButtonDisabled}
                    onEnterKeyPressed={handleRoleChange}
                    onInputChanged={(new_value) => {
                        revertRoleButtonStyle()
                        setRole(new_value)
                    }}
                    buttonExtraClassNames={roleButtonExtraClassNames} />
                <div className="mt-1 sm:col-span-3">The company and role you represent will be visible for other participants to help them better position you during the session if they do not know you. This information is also used for the created report at the end of the session to provide a better insight as to the outcome of the session.</div>
            </div>
        </Fragment>
    )
}








interface IEmailComponentState {
    displayChangeEmail: boolean
    resultMessage: JSX.Element
    progress: string
}
const EmailComponent = (props) => {

    const userData = useUserDataStore()

    const [displayChangeEmail, setDisplayChangeEmail] = useState(false)
    const [resultMessage, setResultMessage] = useState(null)
    const [progress, setProgress] = useState('')

    const [email, setEmail] = useState(userData.email)
    const [password, setPassword] = useState('')

    const [validationErrors, setValidationErrors] = useState([])

    const emailValidator = string().email()
    const passValidator = string().trim().min(1)

    const handleChangeEmail = async () => {
        if (await emailValidator.validate(email) && await passValidator.validate(password)) {
            setProgress('progressing')
            axios.post(`/api/users/${userData.user_id}/modify/email`, {
                email: email,
                password: password,
            }).then(() => {
                setResultMessage(<span className='font-bold text-green-800'>Email change request sent. Please check your new email for a confirmation link. The link is valid only for 24 hours.</span>)
                setProgress('success')
            }).catch((e: AxiosError<{ error: string }>) => {
                if (e.response?.data?.error) {
                    setResultMessage(<span className='font-bold text-rose-800'>{e.response?.data?.error}</span>)
                    setProgress('failed')
                }
            })
        }
    }

    return (
        <Fragment>
            <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:grid-cols-3 '>
                <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">E-mail</label>
                {displayChangeEmail ? (
                    <Fragment>
                        <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:col-span-3 sm:grid-cols-3 '>
                            <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">New e-mail</label>
                            <InputOnly
                                extraClassNames='sm:col-span-2'
                                disabled={progress == 'progressing'}
                                value={email}
                                onInputChanged={(new_value) => {
                                    setEmail(new_value)
                                    setValidationErrors([])
                                    setResultMessage(null)
                                }}
                                validationErrors={validationErrors}
                                placeholder='Provide your new e-mail' />
                        </div>
                        <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:col-span-3 sm:grid-cols-3 '>
                            <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">Password</label>
                            <InputOnly
                                extraClassNames='sm:col-span-2'
                                placeholder='Provide your password'
                                type='password'
                                value={password}
                                disabled={progress == 'progressing'}
                                onInputChanged={(new_value) => {
                                    setValidationErrors([])
                                    setResultMessage(null)
                                    setPassword(new_value)
                                }} />
                        </div>
                        <div className='grid items-baseline grid-cols-2 mb-2 gap-x-2 gap-y-2 sm:gap-y-0 sm:col-span-3 sm:grid-cols-3'>
                            <button type="button" className="inline-flex justify-center w-full px-4 py-2 mr-2 text-base font-medium leading-6 text-indigo-600 transition duration-150 ease-in-out border border-indigo-600 rounded-md shadow-sm sm:col-start-2 hover:border-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo sm:text-sm sm:leading-5"
                                onClick={() => setDisplayChangeEmail(false)}
                                disabled={progress == 'progressing'}>
                                Cancel
                            </button>
                            <button type="button" className="inline-flex items-baseline justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 hover:border-indigo-700 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo sm:text-sm sm:leading-5"
                                onClick={handleChangeEmail}
                                disabled={progress == 'progressing'}>
                                <span>Change e-mail</span>&nbsp;<span className={progress == 'progressing' ? '' : 'hidden'}><i className="fa-solid fa-cog fa-spin"></i></span>
                            </button>
                            {resultMessage ? (
                                <div className='text-sm text-gray-600 sm:col-start-2 sm:col-span-2'>{resultMessage}</div>
                            ) : null}
                        </div>
                        <div className="mt-1 sm:col-span-3">
                            After pressing the <span className="font-bold">Change e-mail</span> button you will get a confirmation e-mail to the new address you provided. Open the link inside that e-mail to finalize this change. Your stored e-mail address will NOT change until you do so.</div>
                    </Fragment>
                ) : (
                    <Fragment>
                        <label className='sm:col-span-3'>Your e-mail address is <b>{userData.email}</b></label>
                        <div className="mt-1 sm:col-span-3">To change your e-mail please click <span className='font-bold underline cursor-pointer' onClick={() => setDisplayChangeEmail(userData.email == "demo@ideate.live" ? false : true)}>here</span>. You need to validate your new e-mail address before these changes are applied.</div>
                    </Fragment>
                )}

            </div>
        </Fragment>
    )
}









interface IPasswordComponentState {
    resultMessage: JSX.Element
    displayChangePass: boolean
    progress: string
}
const PasswordComponent = (props) => {

    const userData = useUserDataStore()

    const [displayChangePass, setDisplayChangePass] = useState(false)
    const [resultMessage, setResultMessage] = useState(null)
    const [progress, setProgress] = useState('')

    const [currentPass, setCurrentPass] = useState('')
    const [newPass1, setNewPass1] = useState('')
    const [newPass2, setNewPass2] = useState('')
    const [passwordStrength, setPasswordStrength] = useState(0)

    const handleChangePass = async () => {
        setProgress('progressing')
        if (currentPass.trim().length == 0) {
            setResultMessage(<div className='text-sm text-rose-600'>Current password not provided</div>)
            setProgress('')
            return
        }
        if (newPass1 != newPass2) {
            setResultMessage(<div className='text-sm text-rose-600'>Passwords do not match</div>)
            setProgress('')
            return
        }
        if (newPass1 == currentPass) {
            setResultMessage(<div className='text-sm text-rose-600'>New Password is same as existing</div>)
            setProgress('')
            return
        }
        if (stringEntropy(newPass1) < MIN_PASSWORD_STRENGTH) {
            setResultMessage(<div className='text-sm text-rose-600'>New Password is not strong enough</div>)
            setProgress('')
            return
        }
        axios.post(`/api/users/${userData.user_id}/modify/password`, {
            new_password: newPass1,
            current_password: currentPass,
        }).then(() => {
            setResultMessage(<div className='text-sm text-green-600'>Password changed successfully</div>)
            setProgress('')
        }).catch((e) => {
            setResultMessage(<div className='text-sm text-rose-600'>{e.response.data.error}</div>)
            setProgress('')
        })
    }

    return (
        <Fragment>
            <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:grid-cols-3 '>
                <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">Password</label>
                {displayChangePass ? (
                    <Fragment>
                        <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:col-span-3 sm:grid-cols-3 '>
                            <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">Current password</label>
                            <InputOnly
                                extraClassNames='sm:col-span-2'
                                type="password"
                                name="password"
                                disabled={progress == 'progressing'}
                                value={currentPass}
                                onInputChanged={(new_value) => {
                                    setResultMessage(null)
                                    setCurrentPass(new_value)
                                }}
                                placeholder='Provide your existing password' />
                        </div>
                        <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:col-span-3 sm:grid-cols-3 '>
                            <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">New Password</label>
                            <InputOnly
                                extraClassNames='sm:col-span-2'
                                placeholder='Provide your new password'
                                type="password"
                                disabled={progress == 'progressing'}
                                autocomplete={false}
                                value={newPass1}
                                onInputChanged={(new_value) => {
                                    setResultMessage(null)
                                    setNewPass1(new_value)
                                    setPasswordStrength(stringEntropy(new_value))
                                }} />
                        </div>
                        <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:col-span-3 sm:grid-cols-3 '>
                            <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">New Password again</label>
                            <InputOnly
                                extraClassNames='sm:col-span-2'
                                placeholder='Provide your new password again'
                                type="password"
                                disabled={progress == 'progressing'}
                                autocomplete={false}
                                value={newPass2}
                                onInputChanged={(new_value) => {
                                    setResultMessage(null)
                                    setNewPass2(new_value)
                                }} />
                        </div>
                        <div className='text-sm grid items-baseline grid-cols-1 col-span-3 mb-2 gap-x-2'>
                            <div className='mb-1'>Password strength meter must be at least 30%. Currently at {passwordStrength}%</div>
                            <div className='w-full flex justify-end h-2 rounded outline-dashed outline outline-1 outline-offset-2 bg-gradient-to-r from-rose-500 via-yellow-500 to-green-500'>
                                <div style={{
                                    width: `${100 - passwordStrength}%`
                                }} className='h-full bg-white'></div>
                            </div>
                        </div>
                        <div className='grid items-baseline grid-cols-2 mb-2 gap-x-2 gap-y-2 sm:gap-y-0 sm:col-span-3 sm:grid-cols-3'>
                            <button type="button" className="inline-flex items-baseline justify-center w-full col-span-2 px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md shadow-sm sm:col-start-2 hover:bg-indigo-700 hover:border-indigo-700 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo sm:text-sm sm:leading-5"
                                onClick={handleChangePass}
                                disabled={userData.email == "demo@ideate.live" ? true : false || progress == 'progressing'}>
                                <span>Change password</span>&nbsp;<span className={progress == 'progressing' ? '' : 'hidden'}><i className="fa-solid fa-cog fa-spin"></i></span>
                            </button>
                            {resultMessage ? (
                                <div className='text-sm text-gray-600 sm:col-start-2 sm:col-span-2'>{resultMessage}</div>
                            ) : null}
                        </div>
                    </Fragment>
                ) : (
                    <Fragment>
                        <div className="mt-1 sm:col-span-3">To change your password please click <span className='font-bold underline cursor-pointer' onClick={() => setDisplayChangePass(userData.email == "demo@ideate.live" ? false : true)}>here</span>.</div>
                    </Fragment>
                )}
            </div>
        </Fragment>
    )
}









const PrivacyComponent = (props) => {

    return (
        <Fragment>
            <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:grid-cols-3 '>
                <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">Cookies & Privacy</label>
                <div className="mt-1 sm:col-span-3">To change your cookies & privacy settings please click <span className='font-bold underline cursor-pointer' onClick={() => {
                    Cookies.remove('cookie-consent')
                    document.dispatchEvent(new Event('displayCookieConsent'))
                }}>here</span>.
                </div>
            </div>
        </Fragment>
    )
}














const DeleteUserComponent = (props) => {

    const userData = useUserDataStore()

    const [currentPass, setCurrentPass] = useState('')

    const [displayDeleteUser, setDisplayDeleteUser] = useState(false)
    const [resultMessage, setResultMessage] = useState(null)
    const [progress, setProgress] = useState('')

    const [validationErrors, setValidationErrors] = useState([])

    const handleDeleteAccount = async () => {
        setProgress('progressing')
        if (userData.metadata?.reg_source == 'google' || currentPass.length > 0) {
            axios.post(`/api/users/${userData.user_id}/delete`, {
                password: userData.metadata?.reg_source == 'google' ? undefined : currentPass
            }).then(() => {
                setResultMessage(<div className='text-sm text-green-600'>Account deleted successfully. We will redirect you to the landing page in 10 seconds.</div>)
                setProgress('')
                setTimeout(() => {
                    location.href = '/'
                }, 10 * 1000)
            }).catch((e) => {
                setResultMessage(<div className='text-sm text-rose-600'>{e.response.data.error}</div>)
                setProgress('')
            })
        } else {
            setProgress('')
        }
    }

    return (
        <Fragment>
            <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:grid-cols-3 '>
                <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">Delete Account</label>
                {displayDeleteUser ? (
                    <Fragment>
                        <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:col-span-3 sm:grid-cols-3'>
                            <label className='font-bold text-rose-800'>Warning</label>
                            <div className='text-rose-800 sm:col-span-2'>This action is irreversible. If you delete your account, all your data will be permanently deleted, including your profile and any created events!</div>
                        </div>
                        {userData.metadata?.reg_source === undefined ?
                            <Fragment>
                                <div className='grid items-baseline grid-cols-1 mb-2 gap-x-2 sm:col-span-3 sm:grid-cols-3'>
                                    <label className="font-bold text-gray-800" htmlFor="flexSwitchCheckDefault">Current password</label>
                                    <InputOnly
                                        extraClassNames='sm:col-span-2'
                                        type="password"
                                        name="password"
                                        value={currentPass}
                                        disabled={progress == 'progressing'}
                                        onInputChanged={(new_value) => {
                                            setValidationErrors([])
                                            setResultMessage(null)
                                            setCurrentPass(new_value)
                                        }}
                                        validationErrors={validationErrors}
                                        placeholder='Provide your existing password' />
                                </div>
                            </Fragment> : null
                        }
                        <div className='grid items-baseline grid-cols-2 mb-2 gap-x-2 gap-y-2 sm:gap-y-0 sm:col-span-3 sm:grid-cols-3'>
                            <button type="button" className="inline-flex items-baseline justify-center w-full col-span-2 px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-rose-600 border border-transparent rounded-md shadow-sm sm:col-start-2 hover:bg-rose-700 hover:border-rose-700 focus:outline-none focus:border-rose-700 focus:shadow-outline-rose sm:text-sm sm:leading-5"
                                onClick={handleDeleteAccount}
                                disabled={userData.email == "demo@ideate.live" ? true : false || progress == 'progressing'}>
                                <span>Delete Account</span>&nbsp;<span className={progress == 'progressing' ? '' : 'hidden'}><i className="fa-solid fa-cog fa-spin"></i></span>
                            </button>
                            {resultMessage ? (
                                <div className='text-sm text-gray-600 sm:col-start-2 sm:col-span-2'>{resultMessage}</div>
                            ) : null}
                        </div>
                    </Fragment>
                ) : (
                    <Fragment>
                        <div className="mt-1 sm:col-span-3">To delete your account please click <span className='font-bold underline cursor-pointer' onClick={() => setDisplayDeleteUser(userData.email == "demo@ideate.live" ? false : true)}>here</span>.</div>
                    </Fragment>
                )}
            </div>
        </Fragment>
    )
}








interface IUserSettings {
    settingsModalOpen: boolean
    closeSettingsModal: () => void
}

export const UserSettings = (props: IUserSettings) => {
    const userData = useUserDataStore()

    return (
        <>
            {
                props.settingsModalOpen &&
                <div className="fixed inset-0 z-50 overflow-y-auto">
                    <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                        <div className="fixed inset-0 transition-opacity">
                            <div className="absolute inset-0 bg-gray-500 opacity-75"
                                onClick={() => props.closeSettingsModal()}></div>
                        </div>
                        <div className="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                            <div className="px-4 pt-5 bg-white sm:pt-6 sm:px-6">
                                <div className="sm:flex sm:items-start">
                                    <div className="text-left">
                                        <h3 className="text-lg font-medium leading-6 text-gray-900 font-display" id="modal-headline">
                                            {userData.user_type == 'registered' ? 'Account Settings' : 'Settings'}
                                        </h3>
                                        <div className="mt-2">
                                            <div className="text-sm leading-5 text-gray-500">

                                                <NameComponent />
                                                <div className='-mx-4 sm:-mx-6 border-b border-black border-opacity-10 h-[1px] mb-2' />
                                                <MetadataComponent />
                                                {userData.user_type == 'registered' ? (
                                                    <Fragment>
                                                        <div className='-mx-4 sm:-mx-6 border-b border-black border-opacity-10 h-[1px] mb-2' />
                                                        {userData.metadata?.reg_source === undefined ?
                                                            <Fragment>
                                                                <EmailComponent />
                                                                <div className='-mx-4 sm:-mx-6 border-b border-black border-opacity-10 h-[1px] mb-2' />
                                                                <PasswordComponent />
                                                                <div className='-mx-4 sm:-mx-6 border-b border-black border-opacity-10 h-[1px] mb-2' />
                                                            </Fragment> : null}

                                                        <PrivacyComponent />
                                                        <div className='-mx-4 sm:-mx-6 border-b border-black border-opacity-10 h-[1px] mb-2' />
                                                        <DeleteUserComponent />
                                                    </Fragment>
                                                ) :
                                                    (userData.user_type == 'participant' ?
                                                        <Fragment>
                                                            <div className='-mx-4 sm:-mx-6 border-b border-black border-opacity-10 h-[1px] mb-2' />
                                                            <PrivacyComponent />
                                                        </Fragment> : null)}
                                                <div className='-mx-4 sm:-mx-6 border-b border-black border-opacity-10 h-[1px]' />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="grid grid-cols-3 px-4 py-3 gap-x-2 sm:px-6">
                                <button
                                    type="button"
                                    className="inline-flex justify-center w-full col-start-2 px-4 py-2 mr-2 text-base font-medium leading-6 text-indigo-600 transition duration-150 ease-in-out border border-indigo-600 rounded-md shadow-sm hover:border-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo sm:text-sm sm:leading-5"
                                    onClick={() => {
                                        props.closeSettingsModal()
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div >
            }
        </>
    )
}

